export const offerYear = (state) => state.offerYear;

export const agreements = (state) => state.agreements;
export const agreementDetails = (state) => state.agreementDetails;
export const agreementDetailsForOfferYear = (state) => state.agreementDetailsForOfferYear;
export const hasBasicInsurance = (state) => state.hasBasicInsurance;
export const isLoadingAgreements = (state) => state.isLoadingAgreements;
export const hasLoadedEditPossible = (state) => state.hasLoadedEditPossible;
export const hasKnownIban = (state) => state.hasKnownIban;
export const hasIbanPayedByInsured = (state) => state.hasIbanPayedByInsured;
export const notShowAnyMore = (state) => state.notShowAnyMore;
